import { useQuery } from "@apollo/client"
import { MenuItem } from "@blueprintjs/core"
import React, { useState } from "react"
import { USERS } from "graphql/selector.queries.gql"
import StaticSelector from "../../Atoms/StaticSelector"
import { debounce } from "lodash-es"
const UserSelector = ({
  group,
  query = undefined,
  filter = undefined,
  ...otherProps
}) => {
  const [search, setQuery] = useState("")
  const { data, loading } = useQuery(query, {
    variables: { group, first: 15, query: search, filter },
  })

  const users = data?.usersByGroup

  function handleChange(srch) {
    if (srch !== search) setQuery(srch)
  }
  const debouncedChange = debounce(handleChange, 500)
  return (
    <StaticSelector
      loading={loading}
      query={search}
      onQueryChange={debouncedChange}
      className="vt-user-selector"
      items={users}
      name={["fullName"]}
      itemRenderer={(item, { handleClick, modifiers, index }) => {
        return (
          <MenuItem
            icon={item?.id ? "user" : null}
            active={modifiers.active}
            key={item?.id ?? `item-${index}`}
            onClick={handleClick}
            text={item?.fullName}
            labelElement={item?.number}
          />
        )
      }}
      {...otherProps}
    />
  )
}

UserSelector.defaultProps = {
  query: USERS,
}
export default UserSelector
